
import VueIconAvatar from '../../icon-avatar.vue';
import VueIcon from "../../icon";
import DecoratorMixin from '../mixin';

export default {
  mixins: [DecoratorMixin],
  components: {
    'vue-icon-avatar': VueIconAvatar,
    'vue-icon': VueIcon,
  },
  computed: {
    profileUrl() {
      return this.$props.item.url;
    },
    messageUrl() {
      return '/User/Pm/Submit?to=' + this.$props.item.name;
    },
    postsUrl() {
      return '/Search?model=Topic&sort=date&user=' + this.$props.item.name;
    },
  },
};
